import { Component, EventEmitter, Input, Output } from "@angular/core"
import Utils from "../../../utils/utils"

@Component({
    selector: "app-search-popular-dropdown",
    templateUrl: "./search-popular-dropdown.component.html",
    styleUrl: "./search-popular-dropdown.component.scss",
    standalone: false,
})
export class SearchPopularDropdownComponent {
    @Input() idPrefix: string = ""
    @Input() popularSearches: string[] = []
    @Input() isOpen: boolean = false
    @Input() activeIndex: number = -1
    @Input() showPopularHeading: boolean = false
    @Output() popularSearchSelected = new EventEmitter<string>()

    onSelect(suggestion: string): void {
        this.popularSearchSelected.emit(suggestion)
    }

    capitalizeFirstLetter(text: string): string {
        if (!text) {
            return text
        }
        return text.charAt(0).toUpperCase() + text.slice(1)
    }

    isLastSuggestion(index: number): boolean {
        return index === this.popularSearches.length - 1
    }

    slugify(value: string | number): string {
        return Utils.slugify(value)
    }
}
